import CopyAllIcon from '@mui/icons-material/CopyAll';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { FunctionFieldProps, useRecordContext } from 'react-admin';
import { TextField } from 'shared/mui/Fields';
import { IconButton } from 'shared/mui/IconButtons';
import { Tooltip } from 'shared/mui/Tooltip';

export type CopyToClipboardTextFieldProps = {
  source?: string;
  value?: string;
  size?: 'small' | 'medium';
} & Omit<FunctionFieldProps, 'render'>;

export const CopyToClipboardTextField: React.FC<CopyToClipboardTextFieldProps> = ({
  source,
  value,
  size = 'medium',
  ...rest
}) => {
  const record = useRecordContext();
  const recordValue = value || record?.[source as string];
  const { tooltipText, handleCopy } = useCopyToClipboard(recordValue);

  return (
    <TextField
      InputLabelProps={{ shrink: true }}
      InputProps={{
        sx: { alignItems: 'flex-start' },
        endAdornment: (
          <Tooltip TransitionProps={{ timeout: 0 }} open={!!tooltipText} title={tooltipText}>
            <IconButton onClick={handleCopy} size="small">
              <CopyAllIcon sx={{ fontSize: 'inherit' }} />
            </IconButton>
          </Tooltip>
        ),
      }}
      disabled
      fullWidth
      label={rest.label}
      multiline
      size={size}
      sx={{ alignItems: 'flex-start' }}
      value={recordValue}
      variant="outlined"
    />
  );
};
